export default function getUserNameInitials(userName = '') {
  const [firstName, lastName] = userName.split(' ');
  if (!lastName) {
    return firstName.slice(0, 2).toUpperCase();
  }
  return `${firstName.slice(0, 1)}${lastName.slice(0, 1)}`.toUpperCase();
}
